import script from "./AutomationEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AutomationEmailModal.vue?vue&type=script&setup=true&lang=js"

import "./AutomationEmailModal.vue?vue&type=style&index=0&id=70bb0c90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70bb0c90"]])

export default __exports__